/**
 * ToolActions Utility Functions
 * Pure functions for analytics tracking
 */

// Re-export the shared feature flag utility
export type { TAIFeatureConfig } from '../../../../../../utils/featureFlags';

export function trackActionsEvent(
  trackEvent: (event: string) => void,
  event: string,
  isFromIndustryTemplate: boolean,
): void {
  if (isFromIndustryTemplate) {
    trackEvent(`front.chat.button.clicked.${event}_from_industry_template`);
  }
}
